import posed from 'react-pose';

export const VideoWrapperPosed = posed.div({
  enter: { opacity: 1, transition: { opacity: { duration: 800 } } },
  exit: { opacity: 0, transition: { opacity: { duration: 800 } } },
});
